import { createContext } from 'react';

const AppContext: any = createContext({});

export default AppContext;
